import React, { useCallback, useEffect } from 'react';
import { Button, FormGroup, InputGroup } from '@blueprintjs/core';
import { useNavigate } from 'react-router-dom';

import { AuthState } from '../types';

import { useAppDispatch, useAppSelector } from '../../../hooks';
import {
  doLogin,
  getUserProfile,
  setLoading,
  setPassword,
  setUsername,
} from '../reducer';

import { REGISTER } from '../routes';
import Loading from '../../../components/Loading';

const LoginForm = () => {
  const dispatch = useAppDispatch();
  const state: AuthState = useAppSelector((state) => state.auth);
  const navigate = useNavigate();

  // If logged, move to main page.
  useEffect(() => {
    dispatch(setLoading(true));
    if (state.session.logged === true) {
      navigate('/');
    }
    dispatch(setLoading(false));
  }, [navigate, state.session.logged, dispatch]);

  useEffect(() => {
    dispatch(setLoading(true));
    if (state.session.logged) {
      dispatch(getUserProfile());
    }
    dispatch(setLoading(false));
  }, [dispatch, state.session.logged]);

  // Login Action
  const handleLogin = useCallback(
    (e: any) => {
      e.preventDefault();
      dispatch(
        doLogin({
          username: state.login.username,
          password: state.login.password,
        }),
      );
    },
    [dispatch, state.login.username, state.login.password],
  );

  // Update Login Fields
  const updateUsername = useCallback(
    (val: string) => {
      dispatch(setUsername(val));
    },
    [dispatch],
  );
  const updatePassword = useCallback(
    (val: string) => {
      dispatch(setPassword(val));
    },
    [dispatch],
  );

  // Navigate ro Register
  const goToRegistration = useCallback(() => {
    navigate(REGISTER());
  }, [navigate]);

  if (state.isLoading) {
    return <Loading message="Loading" />;
  }

  return (
    <div
      className="login-form"
      style={{ maxWidth: '300px', margin: '0 auto', padding: '20px' }}
    >
      <form onSubmit={handleLogin}>
        <FormGroup label="Nome de usuário" labelFor="username-input">
          <InputGroup
            id="username-input"
            placeholder="Digite seu nome de usuário"
            value={state.login.username}
            onChange={(e) => updateUsername(e.target.value)}
          />
        </FormGroup>
        <FormGroup label="Senha" labelFor="password-input">
          <InputGroup
            id="password-input"
            placeholder="Digite sua senha"
            type="password"
            value={state.login.password}
            onChange={(e) => updatePassword(e.target.value)}
          />
        </FormGroup>
        <Button type="submit" intent="primary" icon="log-in">
          Login
        </Button>
        <Button
          type="button"
          intent="primary"
          icon="manually-entered-data"
          minimal
          onClick={goToRegistration}
        >
          Registrar
        </Button>
      </form>
    </div>
  );
};

export default LoginForm;
